/**
 * Automation Requests Handlers (Solicitudes tab — TV1-2377 slice 7)
 *
 * Pure — no side effects, no dispatch, no API.
 */

import { CommandHandlerMap } from '@commandDrivenStateEngine/core/types';
import { RequestsState } from './state';
import { RequestsCommand } from './commands';

type ExtractCommand<T extends string> = Extract<RequestsCommand, { type: T }>;

const handleSetSubGoals = (
  state: RequestsState,
  cmd: ExtractCommand<'automation/requests/data/setSubGoals'>
): RequestsState => ({
  ...state,
  data: { ...state.data, subGoals: cmd.payload.subGoals }
});

const handleSetEvidence = (
  state: RequestsState,
  cmd: ExtractCommand<'automation/requests/data/setEvidence'>
): RequestsState => ({
  ...state,
  data: {
    ...state.data,
    evidence: { ...state.data.evidence, [cmd.payload.subGoalId]: cmd.payload.evidence }
  }
});

const handleSelectRequest = (
  state: RequestsState,
  cmd: ExtractCommand<'automation/requests/ui/selectRequest'>
): RequestsState => ({
  ...state,
  ui: { ...state.ui, selectedRequestId: cmd.payload.requestId }
});

const handleRequestPromotion = (
  state: RequestsState,
  cmd: ExtractCommand<'automation/requests/ui/requestPromotion'>
): RequestsState => ({
  ...state,
  ui: { ...state.ui, pendingPromotion: { subGoalId: cmd.payload.subGoalId }}
});

const handleClearPendingPromotion = ( state: RequestsState ): RequestsState => ({
  ...state,
  ui: { ...state.ui, pendingPromotion: null }
});

const handleRecordInputValues = (
  state: RequestsState,
  cmd: ExtractCommand<'automation/requests/ui/recordInputValues'>
): RequestsState => ({
  ...state,
  ui: { ...state.ui, pendingInputValues: { subGoalId: cmd.payload.subGoalId, values: cmd.payload.values }}
});

const handleClearPendingInputValues = ( state: RequestsState ): RequestsState => ({
  ...state,
  ui: { ...state.ui, pendingInputValues: null }
});

const handleSetInputValuesError = (
  state: RequestsState,
  cmd: ExtractCommand<'automation/requests/data/setInputValuesError'>
): RequestsState => ({
  ...state,
  ui: { ...state.ui, inputValuesError: cmd.payload }
});

const handleSetListLoading = (
  state: RequestsState,
  cmd: ExtractCommand<'automation/requests/loading/setListLoading'>
): RequestsState => ({
  ...state,
  loading: { ...state.loading, listLoading: cmd.payload.isLoading }
});

const handleSetDetailLoading = (
  state: RequestsState,
  cmd: ExtractCommand<'automation/requests/loading/setDetailLoading'>
): RequestsState => ({
  ...state,
  loading: { ...state.loading, detailLoading: cmd.payload.isLoading }
});

export const handlers: CommandHandlerMap<RequestsState, RequestsCommand> = {
  'automation/requests/data/setSubGoals': handleSetSubGoals,
  'automation/requests/data/setEvidence': handleSetEvidence,
  'automation/requests/ui/selectRequest': handleSelectRequest,
  'automation/requests/ui/requestPromotion': handleRequestPromotion,
  'automation/requests/ui/clearPendingPromotion': handleClearPendingPromotion,
  'automation/requests/ui/recordInputValues': handleRecordInputValues,
  'automation/requests/ui/clearPendingInputValues': handleClearPendingInputValues,
  'automation/requests/data/setInputValuesError': handleSetInputValuesError,
  'automation/requests/loading/setListLoading': handleSetListLoading,
  'automation/requests/loading/setDetailLoading': handleSetDetailLoading
};
